export interface EditMasterPlanRequest {
    id:string;
    name?: string;
    description?: string;
    timeZone: string;
    type: number; 
    organizationUnitId?: string;
    additionalData?: Record<string, string>;

}